<template>
  <div id="signup" class="hello bg-light">
    <div id="signup_wrapper"> 
      <b-container id="hero" class="margin-auto rounded">
        <b-row>
          <b-col class="hide-on-mobile">
            <div id="art" class="qds-logo">
              <a href="#" style="display:block; text-align:center;width:100%">
                <img src="static/logo.png" class="img-fluid" style="width:100%;max-width:300px; margin:auto;display:block">
              </a>
            </div>
          </b-col>
          <b-col class="bg-green ctl center">
            <div id="the_form" class="">
              <div id="step_1" v-if="show_step_1">
                <h1 style="margin-bottom:1.7rem">Sign Up</h1>
                <b-form @submit="onSubmit">
                  <b-form-group id="exampleInputGroup1"
                      label=""
                      label-for="exampleInput1"
                      description="">
                    <b-form-input id="exampleInput1"
                          type="text"
                          v-model="form.full_name"
                          required
                          placeholder="Your Full Name">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="exampleInputGroup2"
                      label=""
                      label-for="exampleInput2"
                      description="">
                    <b-form-input id="exampleInput2"
                          type="email"
                          v-model="form.email"
                          required
                          placeholder="Enter email">
                    </b-form-input>
                  </b-form-group>
                  <div class="mobile_form_wrapper">
                    <b-form-group
                        label=""
                        label-for="exampleInput2"
                        description="">
                      <b-form-select class="country_code_picker" v-model="form.country_code" :options="country_code_options"></b-form-select>
                    </b-form-group>
                    <b-form-group 
                        class="mobile_number_input_group"
                        label=""
                        description="">
                      <b-form-input
                            type="tel"
                            v-model="form.mobile"
                            required
                            placeholder="Mobile">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <b-form-group id="exampleInputGroup3"
                      label=""
                      label-for="exampleInput3"
                      description="">
                    <b-form-input id="exampleInput3"
                          type="password"
                          v-model="form.password"
                          required
                          placeholder="Password">
                    </b-form-input>
                  </b-form-group>

                  <p>Have a referral code? (optional)</p>
                  <b-form-group id="exampleInputGroup3"
                      label=""
                      label-for="exampleInput3"
                      description="">
                    <b-form-input id="exampleInput3"
                          type="text"
                          v-model="form.referral_code"
                          placeholder="Referral Code">
                    </b-form-input>
                  </b-form-group>

                  <p class="terms">By clicking on Sign up, you agree to our <a class="blue-link" href='//www.qdspro.com/terms.html'>Terms</a> and <a class="blue-link" href="//www.qdspro.com/privacy.html">Privacy Policy</a>                  
                  <div v-if="keep_recaptcha">
                    <recaptcha ref="recaptcha" @verify="send_otp"></recaptcha>
                  </div>
                  <b-button id="btn-sign-up" @click="send_otp" class="btn-blue" size="lg" variant="primary">Sign Up</b-button> <br><br>
                  <b-link class="blue-link" to="/login">Already have an account? Log in</b-link>
                </b-form>
              </div>
              <div id="step_2" v-if="show_step_2">
                <b-form>
                    <h1 style="margin-bottom:2rem">Enter Otp</h1>
                    <p>Your email should receive a 6 digit otp, please input it below to continue.</p>
                    <b-form-group id="exampleInputGroup1"
                      label=""
                      label-for="otpInput"
                      description="">
                      <b-form-input id="otpInput"
                            type="number"
                            v-model="form.otp"
                            required
                            placeholder="123456">
                      </b-form-input>
                    </b-form-group>
                    <b-button id="btn-verify-otp" @click="executeSignUp" class="btn-blue" size="lg" variant="primary">Verify</b-button>
                </b-form>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import recaptcha from './Recaptcha.vue'
import Validator from '../Utils/Validator.js';
import Constants from '../Constants.js';

let validation = [
  {
    key: "full_name",
    error_message: "Please enter your full name",
    validator: Validator.required
  },
  {
    key: "email",
    error_message: "Please enter your Email",
    validator: Validator.required
  },
  {
    key: "mobile",
    error_message: "Please enter your Mobile number",
    validator: Validator.required
  },
  {
    key: "mobile",
    error_message: "Please enter a valid Mobile Number",
    validator: Validator.valid_mobile
  },
  {
    key: "password",
    error_message: "Please enter your password",
    validator: Validator.required
  }
];

export default {
  name: 'Signup',
  components: {
    recaptcha
  },
  data () {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        email:'',
        password:'',
        full_name:'',
        country_code: '91',
        mobile: '',
        otp:'',
        otp_id:'',
        referral_code:''
      },
      alert: {
        message:'',
        type:'',
        show:false
      },
      keep_recaptcha:true,
      show_step_1:true,
      show_step_2:false
    }
  },
  methods: {
    async onSubmit() {

      var data = {
        email: this.form.email,
        
      }

      const result = await this.$store.dispatch('send-otp',data);

      if(result.status!="success") {
         
        this.$toasted.show(result.error,{type:'error'});
        
      } else {
        
        //this.$router.push('/dashboard');  
      }
    },
    executeRecaptcha () {
      this.$refs.recaptcha.execute()
    },
    async send_otp(response) {

      let form_valid = true;

      for(const [index, field] of validation.entries()) {
        let key = field.key;
        let valid = field.validator(this.form[key]);
        if (!valid) {
          this.$toasted.show(field.error_message,{type:'error'});
          form_valid = false;
          break;
        }
      }

      if(!form_valid) return;

      this.$store.commit('setLoader',true);
      var is_referral_code_valid = await this.verify_referral_code();

      if(!is_referral_code_valid) {
        
        this.$store.commit('setLoader',false);
        this.$toasted.show('Referral Code is invalid!',{type:'error'});
        return;
      }
      
      var data = {
        email: this.form.email,
        captcha: response  
      };
      
      this.$store.commit('setLoader',true);
      try {
        const result = await this.$store.dispatch('send_otp',data);
        this.form.otp_id = result.data.id[0];

        this.$store.commit('setLoader',false);
        this.show_step_1= false;
        this.show_step_2= true;
      } catch(ex) {
        this.$toasted.show(ex.toString(),{type:'error'});
        this.$store.commit('setLoader',false);
      }
    },
    async verify_referral_code() {
      try {
        if(this.form.referral_code == '') {
          return true;
        }
        var verify = await this.$store.dispatch('verify_referral_code', this.form.referral_code);
        if(verify.status == "success") {
          return true;
        } else return false;
      } catch(ex) {
        return false;
      }
    },
    async executeSignUp() {
      this.$store.commit('setLoader',true);
  
      try {
        const result = await this.$store.dispatch('signup',this.form);
        console.log(result);
        
        this.$store.commit('setToken',result.data.token);

				let user = {
					is_logged_in: true
        }
      
        this.$store.commit('setUser',user);      
        this.$store.commit('setLoader',false);

        this.$router.push('/dashboard');
      } catch(ex) {
        this.$store.commit('setLoader',false);
        this.$toasted.show(ex.toString(),{type:'error'});
      }
    }
  },
  computed: {
    country_code_options() {
      return Constants.countries;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobile_form_wrapper {
  display: flex;
  align-items: center;
}
.mobile_number_input_group {
  flex-basis: 0;
  flex-grow: 1;
}
.country_code_picker {
  width: 111px;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media screen and (max-width: 767px) {
  .hide-on-mobile {
    display: none;
  }
  #signup {
    background-color: #77bf43 !important;
  }
}
#signup {
  height:100vh;
  display: flex;
  align-items: center;
}

#signup_wrapper {
  width:100%;
  
}

.blue-link {
  color: #262f3c !important;
  text-decoration: none;
}

#btn-sign-up, #btn-login {
  margin:5px 0;
}

#the_form {
  padding: 30px 20px;
  width: 100%;
  align-self: center;
}
#art {
  background-image: url('../../static/loginbg.jpg');
  background-size: cover;
  background-position: center center;
  height: 100%;
}

#hero {
  max-width: 900px;
}

.cta {
  padding: 30px
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.qds-logo {
  display: flex;
  align-items: center;
}
.qds-logo a {
  display: inline-block;
}

.terms {
  font-size: 0.8rem;
}

@media screen and (min-width: 1280px) {
  #signup {
    height:100vh;
    display: flex;
    align-items: center;
  }


  #the_form {
    padding: 30px 60px;
    width: 100%;
    align-self: center;
  }
}
</style>
  



// WEBPACK FOOTER //
// src/components/Signup.vue